import { Link } from "@components/Link/Link";
import React from "react";
import { clsx } from "clsx";
import { FeaturedCollectionCardProps } from "./withFeaturedCollection";
import { CustomImage } from "@bared/ui";

const Wrapper = (props: any) => (
  <Link
    {...props}
    className={clsx(props.className, "block w-full cursor-pointer")}
  />
);

const Button = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "transition-presentation mt-midi flex w-full items-center text-left font-body group-hover:text-secondary",
    )}
  />
);

const FeaturedCollectionCard = ({
  image,
  link,
}: FeaturedCollectionCardProps) => (
  <Wrapper
    className={"group"}
    to={link?.url}
    tabIndex={0}
    data-promo-name={link?.title}
  >
    <CustomImage data={image} />
    <Button>{link?.title} &rarr;</Button>
  </Wrapper>
);

export default FeaturedCollectionCard;
